"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
const RelayMessage_1 = __importDefault(require("./RelayMessage"));
const Serializer_1 = require("../../../Serializer");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class RelayMessageSerializerV2 extends Serializer_1.Serializer {
    toArray(relayMessage) {
        return [
            VERSION,
            TrackerMessage_1.default.TYPES.RelayMessage,
            relayMessage.requestId,
            relayMessage.originator,
            relayMessage.targetNode,
            relayMessage.subType,
            relayMessage.data
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, originator, targetNode, subType, data] = arr;
        return new RelayMessage_1.default({
            version, requestId, originator, targetNode, subType, data
        });
    }
}
exports.default = RelayMessageSerializerV2;
TrackerMessage_1.default.registerSerializer(VERSION, TrackerMessage_1.default.TYPES.RelayMessage, new RelayMessageSerializerV2());
//# sourceMappingURL=RelayMessageSerializerV2.js.map